import PropTypes from 'prop-types';
import React from 'react';

import { EditFilesElement } from 'contest/components/brief/files-element';

import BriefStore from 'contest/stores/brief-store';
import { connectToStores } from 'fluxible-addons-react';

import briefUpdateUploadAction from 'contest/actions/brief-update-upload';
import briefRemoveUploadAction from 'contest/actions/brief-remove-upload';
import briefAddUploadAction from 'contest/actions/brief-add-upload';
import briefUpdateElementAction from 'contest/actions/brief-update-element';

import castEmptyArrayToObject from 'contest/utils/cast-empty-array-to-object';

import qq from 'fine-uploader/s3.fine-uploader/s3.fine-uploader';

class EditFilesElementWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.addUploads = this.addUploads.bind(this);

        this.onFileRemove = this.onFileRemove.bind(this);
        this.onUploadRemove = this.onUploadRemove.bind(this);

        this.onFileCommentChange = this.onFileCommentChange.bind(this);
        this.onUploadCommentChange = this.onUploadCommentChange.bind(this);

        this.handleSave = this.handleSave.bind(this);
        this.retryUpload = this.retryUpload.bind(this);

        // TODO dhotson .. keep a copy and manage files value locally
        // .. this avoids issues when the underlying outline element value changes and attachment metadata needs to be moved
        this.state = {
            files: props.files,
        };

        this.uploader = this.createUploader(props);
    }

    createUploader(props) {
        const uploader = new qq.s3.FineUploaderBasic({
            signature: {
                endpoint: props.signatureEndpoint,
            },
            request: {
                endpoint: props.s3Endpoint,
                accessKey: props.s3AccessKey,
            },
            objectProperties: {
                bucket: props.s3Bucket,
            },
            multiple: true,
            validation: {
                sizeLimit: this.props.uploadSizeLimit,
            },
            uploadSuccess: {
                endpoint: props.createBriefFileUrl,
            },
            callbacks: {
                onSubmitted: (uploadid, name) => {
                    const file = uploader.getFile(uploadid);

                    // Check browser support for URL.createObjectURL()
                    const URL =
                        window.URL && window.URL.createObjectURL
                            ? window.URL
                            : window.webkitURL && window.webkitURL.createObjectURL
                              ? window.webkitURL
                              : null;

                    const identify = new qq.Identify(file, qq.log);

                    const size = uploader.getSize(uploadid);

                    // Display thumbnail for previewable files < 10Mb
                    const thumb =
                        URL && size < 10 * 1024 * 1024 && identify.isPreviewableSync()
                            ? URL.createObjectURL(file)
                            : undefined;

                    this.context.executeAction(briefAddUploadAction, {
                        path: props.path,
                        uploadid: uploadid,
                        name: name,
                        size: uploader.getSize(uploadid),
                        time: +new Date() / 1000,
                        thumb: thumb,
                        comment: '',
                        type: file.type,
                        progress: 0,
                    });
                },
                onManualRetry: (uploadid, name) => {
                    this.context.executeAction(briefUpdateUploadAction, {
                        path: props.path,
                        uploadid: uploadid,
                        progress: 0,
                        error: false,
                    });
                },
                onError: (uploadid, name, errorReason, xhr) => {
                    if (uploadid) {
                        this.context.executeAction(briefUpdateUploadAction, {
                            path: props.path,
                            uploadid: uploadid,
                            progress: undefined,
                            error: true,
                        });
                    } else {
                        if (window.Bugsnag) {
                            window.Bugsnag.notify(
                                'brief-validation-error',
                                errorReason,
                                {},
                                'info'
                            );
                        }
                        // TODO dhotson -- we might need a place for validation error messages to go
                        alert(errorReason);
                    }
                },
                onComplete: (uploadid, name, responseJSON, xhr) => {
                    const publicId = responseJSON.publicId;

                    this.context.executeAction(briefUpdateUploadAction, {
                        path: props.path,
                        uploadid: uploadid,
                        publicId: publicId,
                        progress: undefined,
                    });
                },
                onAllComplete: (succeeded, failed) => {
                    setTimeout(() => {
                        this.handleSave();
                    }, 10);
                },
                onProgress: (uploadid, name, bytes, totalBytes) => {
                    this.context.executeAction(briefUpdateUploadAction, {
                        path: props.path,
                        uploadid: uploadid,
                        progress: bytes / totalBytes,
                    });
                },
            },
        });

        return uploader;
    }

    addUploads(files) {
        this.uploader.addFiles(files);
    }

    onFileRemove(publicId) {
        this.setState(
            {
                files: this.state.files.filter(a => a.publicId !== publicId),
            },
            () => {
                this.handleSave();
            }
        );
    }

    onUploadRemove(uploadid) {
        this.context.executeAction(briefRemoveUploadAction, {
            path: this.props.path,
            uploadid: uploadid,
        });
        this.uploader.cancel(uploadid);

        setTimeout(() => {
            this.handleSave();
        }, 10);
    }

    onFileCommentChange(publicId, comment) {
        const files = this.state.files.map(a => {
            return a.publicId == publicId ? { ...a, comment: comment } : a;
        });

        this.setState({
            files: files,
        });
    }

    onUploadCommentChange(uploadid, comment) {
        this.context.executeAction(briefUpdateUploadAction, {
            path: this.props.path,
            uploadid: uploadid,
            comment: comment,
        });
    }

    handleSave() {
        if (this.uploader.getInProgress() === 0) {
            const filesValue = this.files()
                .concat(this.uploads())
                .filter(a => a.publicId)
                .map(a => ({ publicId: a.publicId, comment: a.comment }));

            this.context.executeAction(briefUpdateElementAction, {
                section: this.props.sectionKey,
                element: this.props.elementKey,
                value: filesValue,
                saveNow: true,
            });
        }
    }

    retryUpload(uploadid) {
        this.uploader.retry(uploadid);
    }

    files() {
        return this.state.files.map(({ publicId, comment }) => ({
            publicId,
            comment,
            ...this.props.filesMetadata[publicId], // thumb, name, size, type
        }));
    }

    uploads() {
        return this.props.uploads.map(
            uploadid => this.props.uploadsMetadata[this.props.path][uploadid]
        );
    }

    render() {
        return (
            <EditFilesElement
                placeholder={this.props.placeholder}
                downloadAllLink={this.props.downloadAllLink}
                files={this.files()}
                uploads={this.uploads()}
                addUploads={this.addUploads}
                onFileRemove={this.onFileRemove}
                onUploadRemove={this.onUploadRemove}
                onFileCommentChange={this.onFileCommentChange}
                onUploadCommentChange={this.onUploadCommentChange}
                retryUpload={this.retryUpload}
                onSave={this.handleSave}
            />
        );
    }
}

EditFilesElementWrapper.propTypes = {
    path: PropTypes.string.isRequired,
    sectionKey: PropTypes.string.isRequired,
    elementKey: PropTypes.string.isRequired,
    files: PropTypes.arrayOf(
        PropTypes.shape({
            publicId: PropTypes.string.isRequired,
            comment: PropTypes.string,
        })
    ).isRequired,
    filesMetadata: PropTypes.object.isRequired,
    uploads: PropTypes.arrayOf(PropTypes.number).isRequired,
    uploadsMetadata: PropTypes.object.isRequired,
    placeholder: PropTypes.string.isRequired,
    createBriefFileUrl: PropTypes.string.isRequired,
    signatureEndpoint: PropTypes.string.isRequired,
    s3Endpoint: PropTypes.string.isRequired,
    s3AccessKey: PropTypes.string.isRequired,
    s3Bucket: PropTypes.string.isRequired,
    uploadSizeLimit: PropTypes.number.isRequired,
    downloadAllLink: PropTypes.string.isRequired,
};

EditFilesElementWrapper.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

export default connectToStores(EditFilesElementWrapper, [BriefStore], (context, props) => {
    const store = context.getStore(BriefStore);
    const path = props.sectionKey + '/' + props.elementKey;
    const element = store.outline[props.sectionKey].elements[props.elementKey];
    return {
        path: path,
        files: element.value,
        uploads: store.uploads[path] || [],
        uploadsMetadata: store.uploadsMetadata,
        signatureEndpoint: store.signatureEndpoint,
        s3Endpoint: store.s3Endpoint,
        s3AccessKey: store.s3AccessKey,
        s3Bucket: store.s3Bucket,
        filesMetadata: castEmptyArrayToObject(element.metadata.files),
        placeholder: element.trans.commentPlaceholder,
        createBriefFileUrl: store.createBriefFileUrl,
        uploadSizeLimit: store.uploadSizeLimit,
        downloadAllLink: element.metadata.downloadAllLink,
    };
});



// WEBPACK FOOTER //
// ./src/web/js/contest/components/connected/connected-edit-files-element.jsx